import { render, staticRenderFns } from "./Tema2.vue?vue&type=template&id=71d1be80&lang=pug"
import script from "./Tema2.vue?vue&type=script&lang=js"
export * from "./Tema2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports